/**
 * Settings page building blocks (moved out of V2SettingsPage when the page became tabs,
 * founder 2026-10-28): the section card frame passed to HeadingsSection/PlanCreditsSection,
 * the field label, and the save-flash type.
 */
import type { ReactNode } from 'react';

import { Card } from '../ui/card';

/** A short non-fatal banner shown after a save. */
export type SaveFlash = { kind: 'ok' | 'bad'; msg: string } | null;

/** Section card with an uppercase title + optional subtitle. */
export function Section({
  title,
  sub,
  children,
  footer,
}: {
  title: string;
  sub?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <Card className="p-0">
      <div className="px-[18px] pt-[16px] pb-[12px] border-b border-[var(--bd-subtle)]">
        <h2 className="m-0 text-[11px] font-[650] uppercase tracking-[.06em] text-[var(--tx-lo)]">
          {title}
        </h2>
        {sub && <p className="mt-1 mb-0 text-[12px] text-[var(--tx-faint)]">{sub}</p>}
      </div>
      <div className="p-[18px]">{children}</div>
      {footer && (
        <div className="px-[18px] py-[12px] border-t border-[var(--bd-subtle)] flex justify-end">
          {footer}
        </div>
      )}
    </Card>
  );
}

/** Field label used above inputs/selects. */
export function FieldLabel({ children, htmlFor }: { children: ReactNode; htmlFor?: string }) {
  return (
    <label
      htmlFor={htmlFor}
      className="block mb-[6px] text-[11px] font-[560] tracking-[.02em] text-[var(--tx-lo)]"
    >
      {children}
    </label>
  );
}
